<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="$t('commonInfo.actionModifyDeliveryTime')" 
		:visible.sync="visible" 
		:close-on-click-modal="false" 
		width="600px"
		:append-to-body="true" 
		@close="handleClose"
	>
		<el-form label-width="160px" :model="timeForm" ref="timeForm" :inline="true">
			<el-form-item :label="$t('commonInfo.deliveryDate')" prop="delivery_date">
				<el-date-picker
				  clearable
				  size="small"
				  v-model="timeForm.delivery_date"
				  :type="orderData.orderType == 'OWH'?'date':'datetime'"
					style="width: 320px;"
				  value-format="yyyy-MM-dd HH:mm:ss"
				  :picker-options="deliveryPickerOptions"
				  :placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryDate')"
				></el-date-picker>
			</el-form-item>
			<!-- 预约送仓时间提示 -->
					<div class="deliveryTip">
						<h4><i class="el-icon-warning"></i>预约送仓时间选择规则：</h4>
						<span>1、选择送仓时间为沙特时间</span>
						<span>2、每周五沙特公休</span>
						<span>3、国内推单当天时间0点-15点为正常推单，</span>
						<label>15点到20点为加急推单，需要收取加急费用，</label>
						<label>20点过后不能推当天单</label>
						<span>4、提前一天以上为正常推单</span>
					</div>
			<el-form-item>
				<SingleUploadPDF
				  v-model="labelFlienName"
					:tipText="$t('commonInfo.deliveryFileTips')"
					:preFile="labelPreName"
				  @input="getLabelInfo"
				></SingleUploadPDF>
			</el-form-item>
		</el-form>
		<el-footer style="height: 70px; position: relative;">
			<el-button :disabled="timeLoading" :loading="timeLoading" type="primary" @click="submitTime" style="float: right;">{{timeLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}</el-button>
			<el-button :disabled="timeLoading" @click="handleClose" style="float: right; margin: 0 10px;">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
		</el-footer>
	</el-dialog>
</template>

<script>
import SingleUploadPDF from "@/components/upload/singleUploadPDF";

export default {
	name: 'UpdateApTiem',
	components: {
		SingleUploadPDF
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		orderData: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			timeLoading: false,
			timeForm: {
				customer_order_no: '',
				delivery_date: '',
				receiver_address: '',
				receiver_detail_address: '',
				label_url: '',
				order_category: '',
				exp: '',
			},
			labelFlienName: '',
			labelLink: '',
			labelPreName: [],
		    // 预约送仓时间限制选择范围
				deliveryPickerOptions: {// 限制送仓时间的选择范围
				  disabledDate(time) {
				  	let nowDate = Date.now();
				  	// 国内时间当天下单：0-15点为正常派送时间 15-20点为加急派送时间 20点过后则不能下当天单
				  	let nowHour = new Date().getHours(),nowMin = new Date().getMinutes(),nowSecond = new Date().getSeconds();
				  	if(nowHour < 15){
				  		nowDate = nowDate - 24 * 60 * 60 * 1000;//可选当天
				  	}else if(nowHour >= 15 && nowHour < 20){
				  		nowDate = nowDate - 24 * 60 * 60 * 1000;//可选当天
				  	}else{//不可选当天
				  	}
				  	let nowDay = new Date(time).getDay();//周几
				  	// 超过当前时间的日期不可选
				  	return nowDate > time.getTime() || 
				  	nowDay == 5
				  },
				  selectableRange: '10:00:00 - 18:00:00',
				}
		};
	},
	watch: {
		visible(val) {
			if (val) {
				this.initForm();
			}
		},
		// 监听客户选择的派送时间，用于限制小时的选择范围
			'timeForm.delivery_date':function(newVal,oldVal){
				console.log(newVal);
				// 判断是否选择当天，不是当天可以选择小时10-18点
				let nowDate = new Date();
				let chooseDate = new Date(newVal);
				let updateTime = '';
				// 当天下单
				if(nowDate.getMonth() + nowDate.getDate() == chooseDate.getMonth() + chooseDate.getDate()){
					if(nowDate.getHours() < 15){
						updateTime = '10:00:00 - 18:00:00';
					}else if(nowDate.getHours() >= 15 && nowDate.getHours() < 20){
						updateTime = nowDate.getHours() - 4 + ':00:00 - 18:00:00';
					}
				}else{// 不是当天不用限制小时
					updateTime = '10:00:00 - 18:00:00';
				}
				this.$set(this.deliveryPickerOptions,'selectableRange',updateTime);
			}
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		initForm() {
			this.timeForm.customer_order_no = this.orderData.customerOrderNo || '';
			this.timeForm.receiver_address = this.orderData.receiverAddress || '';
			this.timeForm.receiver_detail_address = this.orderData.receiverDetailAddress || '';
			this.timeForm.exp = this.orderData.exp || '';
			this.timeForm.order_category = this.orderData.orderType || '';
			this.timeForm.delivery_date = '';
			this.labelFlienName = '';
			this.labelLink = '';
			this.labelPreName = [];
		},
		getLabelInfo(data) {
			this.labelLink = data;
			if(data != ''){
				//修改upload的preview预览
				let str = data.split("~");
				this.labelPreName = [{
					name:str[1],
					url:data,
				}]
			}
		},
		submitTime() {
			if(this.timeForm.delivery_date == ''){
				return this.$message.warning(this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.deliveryDate'));
			}
			if(this.labelLink == ''){
				return this.$message.warning(this.$t('tipsInfo.submitOrderDeliveryFileTips'));
			}
			this.timeForm.label_url = this.labelLink;
			//客户确认
			this.$confirm(
					this.$t('ksaWhFBXOrderPage.submitDeliveryTimeTips') + this.timeForm.delivery_date,
					this.$t('tipsInfo.warning'), {
						confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
						cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
						type: "warning"
					}
				).then(() => {
					this.timeLoading = true;
					this.$http
						.post("/toborder/wms/fulfillment/update", this.timeForm)
						.then(res => {
							if (res.code === 200) {
								this.$message.success(this.$t('tipsInfo.success'));
								this.$emit('update:visible', false);
								this.timeLoading = false;
								this.$emit('refreshList');
							} else {
								this.timeLoading = false;
								this.$message.error(res.msg);
							}
						});
				});
		}
	}
};
</script>

<style scoped>
.deliveryTip{
	width: 330px;
	margin-left: 150px;
	margin-bottom: 10px;
	background-color: #fffdd6;
	border-radius: 4px;
	padding: 5px 10px;
}
.deliveryTip h4{
	margin: 0;
	line-height: 30px;
}
.deliveryTip i{
	margin: 0 5px;
}
.deliveryTip span{
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 20px;
}
.deliveryTip label{
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 40px;
	font-weight: bold;
}
/* 阿拉伯语样式 */
[lang="ar"] {
	::v-deep .el-dialog__headerbtn{
		right: auto;
		left: 20px;
	}
	::v-deep .el-dialog__footer {
		text-align: left;
		.el-button {
			margin: 0 10px;
		}
	}
}
</style>